import * as yup from 'yup';

import { Method } from '../types/method';

const defaultValidation = {
  name: yup.string(),
  description: yup.string(),
  density: yup.number().transform((value) => (isNaN(value) ? undefined : value)),
  imageVolume: yup.number().transform((value) => (isNaN(value) ? undefined : value)),
  temperature: yup.number().transform((value) => (isNaN(value) ? undefined : value)),
  ph: yup.number().transform((value) => (isNaN(value) ? undefined : value)),
  turbidity: yup.number().transform((value) => (isNaN(value) ? undefined : value)),
  dilutionSample1: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required('commonValidation.fieldRequired'),
  dilutionSample2: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required('commonValidation.fieldRequired'),
};

export const getBatchCreationValidation = (type: Method) => {
  const validatioSchema = {
    [Method.WineConz]: yup.object(defaultValidation),

    [Method.WineConzViab]: yup.object({
      ...defaultValidation,
      dilutionStain1: yup
        .number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .required('commonValidation.fieldRequired'),
      dilutionStain2: yup
        .number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .required('commonValidation.fieldRequired'),
    }),

    [Method.WineBrett]: yup.object({}),
    [Method.WineManualCnt]: yup.object({}),

    [Method.Yeast2Conz]: yup.object(defaultValidation),
    [Method.Yeast2Brett]: yup.object({}),
    [Method.Yeast2ConzViab]: yup.object(defaultValidation),

    [Method.BioEthConz]: yup.object(defaultValidation),
    [Method.BioEthrett]: yup.object({}),
    [Method.BioEthConzViab]: yup.object({
      ...defaultValidation,
      dilutionStain1: yup
        .number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .required('commonValidation.fieldRequired'),
      dilutionStain2: yup
        .number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .required('commonValidation.fieldRequired'),
    }),
  };
  return validatioSchema[type];
};
